import { useLoaderData } from 'react-router-dom';

import Location from '@r6digital/rapidstor-types/react/entities/Location';
import Deal from '@r6digital/rapidstor-types/types/Deal';

import {
    getDealPriceDisplay as getDealPriceDisplayFn,
    getPriceDifferenceDisplay as getPriceDifferenceDisplayFn,
    type PriceDifferenceOptions,
} from '@/core/utils/dealDisplay';

export function useDealDisplay() {
    const location = useLoaderData() as Location;

    return {
        getDealPriceDisplay: (deal: Deal, effectiveRate: number, shortForm?: boolean): string => getDealPriceDisplayFn(deal, effectiveRate, location, shortForm),

        getPriceDifferenceDisplay: (
            sourceRate: number,
            targetRate: number,
            sourceDeal?: Deal,
            targetDeal?: Deal,
            options?: PriceDifferenceOptions,
        ): string => getPriceDifferenceDisplayFn(sourceRate, targetRate, sourceDeal, targetDeal, location, options),
    };
}
